import { render, staticRenderFns } from "./newAddCoupons.vue?vue&type=template&id=b769654e"
import script from "./newAddCoupons.vue?vue&type=script&lang=js"
export * from "./newAddCoupons.vue?vue&type=script&lang=js"
import style0 from "./newAddCoupons.vue?vue&type=style&index=0&id=b769654e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports